<template>
  <div class="tinto-page">
    <Loading :isActive="loading" />

    <div class="tinto-embalagem-info">
      <fa-icon icon="info-circle" class="mr-2" />
      Defina um <strong>valor adicional fixo (R$)</strong> por embalagem. Ele é somado uma única vez ao
      preço final da tinta tintométrica (taxa de serviço por tamanho de lata). Deixe <strong>0</strong> para não cobrar.
    </div>

    <!-- ===== FILTERS ===== -->
    <div class="tinto-filters">
      <CRow>
        <CCol md="6">
          <input class="form-control" v-model="filtros.termo" placeholder="Buscar por nome..." @keyup.enter="load()" />
        </CCol>
        <CCol md="4">
          <select class="form-control" v-model="filtros.fabricanteId" @change="load()">
            <option value="">Todos os fabricantes</option>
            <option v-for="(n,id) in fabricantes" :key="id" :value="id">{{ n }}</option>
          </select>
        </CCol>
        <CCol md="2">
          <button class="button button-primary" @click="load()">Buscar</button>
        </CCol>
      </CRow>
    </div>

    <!-- ===== TABLE ===== -->
    <div class="tinto-table-wrap">
      <table class="tinto-table">
        <thead><tr>
          <th style="width:50px">ID</th>
          <th style="width:260px" class="tinto-sortable" :class="{'is-active': sort.by==='nome'}" @click="sortBy('nome')">
            Nome<fa-icon :icon="sort.by==='nome' ? (sort.dir==='asc' ? 'arrow-up' : 'arrow-down') : 'arrow-down'" class="sort-icon" />
          </th>
          <th style="width:120px">Volume</th>
          <th style="width:190px">Valor adicional (R$)</th>
          <th style="width:120px"></th>
        </tr></thead>
        <tbody>
          <tr v-if="items.length === 0"><td colspan="5" class="tinto-table__empty">Nenhuma embalagem encontrada</td></tr>
          <tr v-for="r in items" :key="r.id">
            <td>{{ r.id }}</td>
            <td class="tinto-table__primary">{{ r.nome }}</td>
            <td>
              <span v-if="r.volumeMl">{{ formatVolume(r.volumeMl) }}</span>
              <span v-else class="tinto-table__muted">—</span>
            </td>
            <td>
              <input
                type="number" min="0" step="0.01"
                class="form-control tinto-embalagem-input"
                v-model.number="r.valorAdicional"
                @keyup.enter="salvar(r)"
              />
            </td>
            <td>
              <button class="button button-primary" :disabled="r._saving" @click="salvar(r)">
                <fa-icon v-if="r._saving" icon="spinner" spin />
                <fa-icon v-else icon="save" /> Salvar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="tinto-pagination" v-if="paginator.last_page > 1">
      <pagination :data="paginator" :limit="5" @pagination-change-page="load" />
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import listagemMixin from "./listagemMixin";
import { put } from '@/helpers/apiRequest';

export default {
  name: "tintometrico-embalagem",
  components: { Loading },
  mixins: [listagemMixin],
  props: ['fabricantes'],

  data() {
    return {
      listagemEndpoint: '/admin/tintometrico/embalagem',
      sort: { by: 'nome', dir: 'asc' },
      filtros: { termo: '', fabricanteId: '' },
    };
  },

  methods: {
    formatVolume(ml) {
      return ml >= 1000 ? (ml / 1000).toFixed(1) + 'L' : ml + 'ml';
    },

    salvar(embalagem) {
      const valor = Number(embalagem.valorAdicional);

      if (isNaN(valor) || valor < 0) {
        this.$swal({ title: 'Valor inválido', text: 'Informe um valor maior ou igual a zero.', icon: 'warning' });
        return;
      }

      this.$set(embalagem, '_saving', true);

      put(`/admin/tintometrico/embalagem/${embalagem.id}`, { valor_adicional: valor })
        .then(() => {
          this.$swal({
            title: 'Salvo',
            text: `Valor adicional da embalagem "${embalagem.nome}" atualizado.`,
            icon: 'success',
            timer: 1800,
            showConfirmButton: false,
          });
          // Recarrega a página atual para refletir o valor efetivamente persistido
          // (alinhado ao padrão das abas irmãs, que recarregam após salvar).
          this.load(this.paginator.current_page || 1);
        })
        .catch(e => { this.$swal({ title: 'Erro', text: e.message, icon: 'error' }); })
        .finally(() => { this.$set(embalagem, '_saving', false); });
    },
  },
};
</script>

<style scoped>
.tinto-embalagem-info {
  background: #eef4ff;
  border: 1px solid #cfe0ff;
  color: #344054;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 14px;
}
.tinto-embalagem-input {
  max-width: 150px;
  display: inline-block;
}
</style>
